export default __webpack_public_path__ + "static/media/icon-identity-information.2ec8ff37.svg";